import {OrderTypes, SORT_PREFIX} from '@/constants'

import {
    getFiltersFromSearchParams,
    getKeyWidthPrefix,
    getTransformedFilterToObjectAndType,
} from '@/utils'

export const getQueryParamsFromSearchParams = (searchParams, queryParamsInitial) => {
    const searchParamsObject = Object.fromEntries([...searchParams])

    return {
        ...queryParamsInitial,
        page: searchParamsObject.page
            ? Number(searchParamsObject.page)
            : queryParamsInitial.page,

        limit: searchParamsObject.limit
            ? Number(searchParamsObject.limit)
            : queryParamsInitial.limit,

        sortKey: searchParamsObject.sortKey || queryParamsInitial.sortKey,

        sortDirection:
            searchParamsObject.sortDirection === OrderTypes.Desc
                ? OrderTypes.Desc
                : searchParamsObject.sortDirection === OrderTypes.Asc
                    ? OrderTypes.Asc
                    : queryParamsInitial.sortDirection,

        filters: getFiltersFromSearchParams(searchParamsObject),

        isShowDeletedItems:
            Boolean(Number(searchParamsObject.isShowDeletedItems)) ||
            queryParamsInitial.isShowDeletedItems,
    }
}

export const setSearchParamsToState = (
    searchParams,
    setQueryParams,
    queryParamsInitial,
) => {
    setQueryParams(getQueryParamsFromSearchParams(searchParams, queryParamsInitial))
}

export const getVariables = (
    queryParams,
    instructionTypeForFilter,
) => {
    let variables = {
        page: queryParams?.page,
        limit: queryParams?.limit,
    }

    if (queryParams?.sortKey && queryParams?.sortDirection) {
        variables[getKeyWidthPrefix(queryParams.sortKey, SORT_PREFIX)] =
            queryParams.sortDirection
    }

    if (queryParams?.filters) {
        variables = {
            ...variables,
            ...getTransformedFilterToObjectAndType(
                queryParams.filters,
                instructionTypeForFilter,
            ),
        }
    }

    if (!queryParams?.isShowDeletedItems) {
        variables['deletedAt'] = null
    }

    return variables
}
